import React from 'react'

const PageNotFound = () => {
  return (
    <div className='h-[80vh] w-full items-center flex justify-center text-center'>
        <div>
            <h1 className='text-7xl font-bold space-x-0 font-public-sans'>4<span className='text-green-700'>0</span>4</h1>
            <h6 className='font-public-sans text-lg'>Sorry, we can't find the page you are looking for.:(</h6>
        </div>
    </div>
  )
}

export default PageNotFound